import { Action, SET_IS_ENABLE_SEND_TO_EMPLOYER } from "../actions/eSign";

const initialState = {
  isEnableSendToEmployer: false,
};
export default function enableSendToEmployer(
  state = initialState,
  action: Action
) {
  switch (action.type) {
    case SET_IS_ENABLE_SEND_TO_EMPLOYER:
      return {
        ...state,
        isEnableSendToEmployer: action.state,
      };
    default:
      return state;
  }
}
